import { useContext } from 'react';
import { IocContext } from './IocContext';
export function useInject(identifier) {
    const container = useContext(IocContext);
    if (!container) {
        throw new Error('Ioc container is empty');
    }
    return container.get(identifier);
}
